export var UhdHdrCodec = /*#__PURE__*/ function(UhdHdrCodec) {
    UhdHdrCodec["Uhd"] = "Uhd";
    // 4K
    UhdHdrCodec["Hdr10"] = "Hdr10";
    UhdHdrCodec["Hdr10Plus"] = "Hdr10Plus";
    UhdHdrCodec["HdrHlg"] = "HdrHlg";
    UhdHdrCodec["DolbyVision"] = "DolbyVision";
    return UhdHdrCodec;
}({});
export var AudioCodecType = /*#__PURE__*/ function(AudioCodecType) {
    AudioCodecType["MPEG_4_LC"] = "MPEG_4_LC";
    // AAC LC (Low Complexity)
    AudioCodecType["MPEG_4_SBR"] = "MPEG_4_SBR";
    // SBR (Spectral Band Replication)
    AudioCodecType["DolbyDigital"] = "DolbyDigital";
    AudioCodecType["DolbyDigitalPlus"] = "DolbyDigitalPlus";
    return AudioCodecType;
}({});
export var DrmKind = /*#__PURE__*/ function(DrmKind) {
    DrmKind["Widevine"] = "com.widevine.alpha";
    DrmKind["PlayReady"] = "com.microsoft.playready.recommended";
    DrmKind["FairPlay"] = "com.apple.fps";
    return DrmKind;
}({});
export var StatusPolicies = /*#__PURE__*/ function(StatusPolicies) {
    StatusPolicies["USABLE"] = "usable";
    return StatusPolicies;
}({});

//# sourceMappingURL=probe-utils.enums.js.map